import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=6b4a38c2&"
import script from "./HomeScreen.vue?vue&type=script&lang=js&"
export * from "./HomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=6b4a38c2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4a38c2')) {
      api.createRecord('6b4a38c2', component.options)
    } else {
      api.reload('6b4a38c2', component.options)
    }
    module.hot.accept("./HomeScreen.vue?vue&type=template&id=6b4a38c2&", function () {
      api.rerender('6b4a38c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/HomeScreen.vue"
export default component.exports